import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import readPendingGridSearch from "~/helpers/search/readPendingGridSearch";
import { useAppDispatch } from "~/hooks/reduxHooks";
import { updateGridSearchText } from "~/store/layoutSlice";

const useClearGridSearchOnRouteChange = (): void => {
	const dispatch = useAppDispatch();
	const { pathname, state } = useLocation();
	const previousPathnameRef = useRef(pathname);

	useEffect(() => {
		if (previousPathnameRef.current === pathname) {
			return;
		}
		previousPathnameRef.current = pathname;
		dispatch(updateGridSearchText(readPendingGridSearch(state) ?? ""));
	}, [pathname, state]);
};

export default useClearGridSearchOnRouteChange;
